import { gql, QueryResult, useQuery } from '@apollo/client';

import { ABVisitorContextQuery } from './__generated__/ABVisitorContextQuery';

const useABVisitorContext = (): UseABVisitorContextResult => {
  const { data, ...requestState } = useQuery<ABVisitorContextQuery>(
    AB_VISITOR_CONTEXT_QUERY
  );

  return {
    ...requestState,
    abVisitorId: data?.abVisitorId,
    deviceType: data?.deviceType,
    referrer: data?.referrer,
    referrerHost: data?.referrerHost,
  };
};

export default useABVisitorContext;

type UseABVisitorContextResult = Partial<ABVisitorContextQuery> &
  Omit<QueryResult<ABVisitorContextQuery>, 'data'>;

export const AB_VISITOR_CONTEXT_QUERY = gql`
  query ABVisitorContextQuery {
    abVisitorId @client
    deviceType @client
    referrer @client
    referrerHost @client
  }
`;
